import { useNavigate } from 'react-router'
import IcBaselineMailOutline from '~icons/ic/baseline-mail-outline'
import { UIButton } from 'src/components/ui/Button'
import { UIDialog } from 'src/components/ui/Modal'
import Text from 'src/components/ui/Text'
import { navigateToNativePage } from 'src/utils/jsBridge/implementation'
import { NativeNavigation } from 'src/utils/jsBridge/nativeNavigation'
import { track } from 'src/utils/tracker'

export function openForceVerifyEmailDialog(options: {
  supportNativeEditAccount?: boolean
}) {
  track('force_verify_email_dialog_shown')
  UIDialog.create({
    dismissable: true,
    type: 'dialog',
    children: ({ close }) => (
      <ForceVerifyEmailDialogContent
        onClose={close}
        supportNativeEditAccount={options.supportNativeEditAccount}
      />
    ),
  })
}

function ForceVerifyEmailDialogContent(props: {
  onClose: () => void
  supportNativeEditAccount?: boolean
}) {
  const navigate = useNavigate()

  const onVerifyEmail = () => {
    track('force_verify_email_verify_click')
    if (props.supportNativeEditAccount) {
      navigateToNativePage({
        route: NativeNavigation.editProfile(),
      })
    } else {
      navigate('/profile/edit/accounts')
    }
    props.onClose()
  }

  const onContactSupport = () => {
    track('force_verify_email_contact_support_click')
    if (props.supportNativeEditAccount) {
      navigateToNativePage({
        route: NativeNavigation.support(),
      })
    } else {
      navigate('/feedback')
    }
    props.onClose()
  }

  return (
    <div className="flex flex-col items-center gap-4 p-6">
      <div className="flex size-16 items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/30">
        <IcBaselineMailOutline className="size-8 text-purple-500" />
      </div>
      <h2 className="text-lg font-semibold">
        <Text i18nKey="user:profile.email.force-verify-email-dialog.title" />
      </h2>
      <p className="text-center text-sm text-zinc-600 dark:text-zinc-400">
        <Text i18nKey="user:profile.email.force-verify-email-dialog.description" />
      </p>
      <div className="flex w-full flex-col items-center gap-2">
        <UIButton variant="filled" className="w-full" onPress={onVerifyEmail}>
          <Text i18nKey="user:profile.email.force-verify-email-dialog.verify" />
        </UIButton>
        <UIButton
          variant="ghost"
          className="text-sm text-zinc-500"
          onPress={onContactSupport}
        >
          <Text i18nKey="user:profile.email.force-verify-email-dialog.contact-support" />
        </UIButton>
      </div>
    </div>
  )
}
